import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';

export default function DesktopCalculatorButton({
  disabled,
  onClick,
}: {
  disabled: boolean;
  onClick: () => void;
}) {
  const { t } = useTranslation('common');
  return (
    <div className="hidden lg:block">
      <Button
        disabled={disabled}
        onClick={onClick}
        size="m"
        wide
        outline
        dataTest="sidebar-btn-edit-calculator"
      >
        {t('edit')}
      </Button>
    </div>
  );
}
